import { options } from './options';

export const convertFilterToApiFilter = (filterId) => options[filterId] && options[filterId].apiKey;

export const convertFilterToLegacyApiFilter = (filterId) =>
  options[filterId] && (options[filterId].legacyApiKey || options[filterId].apiKey);
